export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12138.b44de01a.jpg";